import { Yield } from '../../abacus/interfaces/yield.interface'

export const organisationYields: Yield[] = [
  {
    label: 'Name',
    property: 'name'
  },
  {
    label: 'Description',
    property: 'description'
  }
]
